// extracted by mini-css-extract-plugin
module.exports = {"mask":"styles_mask__pn_fr"};